import type { Visualize3dComponent } from './visualize3d-component';
import type { ThreeJsMaterial } from '../models/three-js-material';
import type { Visualize3dComponentCreator } from './visualize3d-component-creator';

export interface ThreeJsMaterialModifierComponent extends Visualize3dComponent {
  material: ThreeJsMaterial;
}

export const threeJsMaterialModifierComponentCreator: Visualize3dComponentCreator<ThreeJsMaterialModifierComponent> = {
  createComponent: createThreeJsMaterialModifierComponent,
};

/**
 * Create new instance of ThreeJsMaterialModifier
 */
export function createThreeJsMaterialModifierComponent(): ThreeJsMaterialModifierComponent {
  return {
    $type: 'MagiCADCore.Visualize3D.ThreeJS.DataTransfer.ThreeJsMaterialModifierDto, MagiCADCore.Visualize3D.ThreeJS',
    type: 'ThreeJsMaterialModifier',
    material: {
      parameters: null,
      preserveColor: false,
      materialType: 'MeshLambertMaterial',
    },
  };
}
